export default "//static.tradera.net/touchweb/static/output/images/live.2f166a19.svg";